module.exports = __webpack_public_path__ + "static/img/saoyisao.5e2f54f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/saoyisao.png
// module id = Mnkl
// module chunks = 1